import type { ComponentType } from "react";
import type { SectionType } from "@repo/backend/schema/siteConfig";

export interface SectionComponentProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  props: Record<string, any>;
  clientId: string;
}

export type SectionComponent = ComponentType<SectionComponentProps>;

// Registry: type → variant → component
const registry = new Map<string, Map<string, SectionComponent>>();

export function registerSection(
  type: SectionType | string,
  variant: string,
  component: SectionComponent
): void {
  if (!registry.has(type)) {
    registry.set(type, new Map());
  }
  registry.get(type)!.set(variant, component);
}

export function lookupSection(
  type: string,
  variant: string
): SectionComponent | undefined {
  return registry.get(type)?.get(variant);
}

export function listRegisteredVariants(type: string): string[] {
  return Array.from(registry.get(type)?.keys() ?? []);
}
